import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { fetchApp } from "src/actions/community/appsActions";
import { selectAppById, setEditId } from "../../../store/community/appsSlice";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Settings from "./_partials/_Settings";
import Feed from "./_partials/_Feed";
import Email from "./_partials/_Email";
import Details from "./_partials/_Details";
import Tabs from "src/componets/Tabs";
import { ButtonEdit } from "src/componets/Buttons";
import SidebarShow from "./_partials/_SidebarShow";
import Edit from "./Edit";
import usePermissions from "src/hooks/usePermissions";

const Show: React.FC = () => {
  const { app_id } = useParams();
  const dispatch = useAppDispatch();
  const app = useAppSelector(state => app_id ? selectAppById(state, app_id) : undefined);
  const { write_community } = usePermissions();

  useEffect(() => {
    if (app_id) {
      dispatch(fetchApp(app_id));
    }
  }, [app_id, dispatch]);

  function onClickEdit() {
    if (app) {
      dispatch(setEditId(app.id));
    }
  }

  return (
    <PageLayout className='v-apps-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            app &&
              <SummaryShow
                title={app.name}
                image={app.icon_url}
                createdAt={app.created_at}
                updatedAt={app.updated_at}
                actions={write_community ? [
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ] : []}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Details', key: 'details', children: <Details app={app} /> },
              ...(write_community ? [
                { label: 'Settings', key: 'settings', children: <Settings app={app} /> },
                { label: 'Email', key: 'email', children: <Email app={app} /> },
                { label: 'Feed', key: 'feed', children: <Feed app={app} /> },
              ] : []),
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow app={app} />
    </PageLayout>
  )
}

export default Show;
